function init() {
    InitHeroSelector();
}
function InitHeroSelector() {

    $(document).ready(() => {
        const selectBox = $('.hero-selector')
        $(selectBox).on('change', function () {
            var link = $(this).find(':selected').data('link');
            if (link) {
                window.location.href = link;
            }
            // $(tabContentElem).find('.link-cta').attr('href', link);
        })
    })
}
export {
    init
}